import React from 'react'
import { Row, Col, List, Spin, Tag } from 'antd';
import { ArrowRightOutlined, VerticalAlignTopOutlined, EyeOutlined, LikeOutlined } from '@ant-design/icons';
import { withRouter } from "react-router-dom"
import { connect } from 'react-redux'
import { updateCategoryId } from '@/store/actions'
import API from '@/api'
import store from '@/store'

@withRouter
@connect(
  state => ({
    categories: state.categories
  }),
  { updateCategoryId }
)
class HomeList extends React.Component {
  constructor (props) {
    super(props)
    this.BottomChild = React.createRef() // 此处初始化

    this.state = {
      list: [],
      isLoading: false,
      hasMore: true,
      fetchCategoryId: null,
      fetchHomeSearchKey: null
    }

    store.subscribe(() => {
      const { curCategoryId, homeSearchKey } = store.getState()
      console.log('homeSearchKey', homeSearchKey)
      if (homeSearchKey !== this.state.fetchHomeSearchKey) {
        this.setState({
          fetchHomeSearchKey: homeSearchKey
        }, this.initData)
      }

      if (curCategoryId !== this.state.fetchCategoryId) {
        this.setState({
          fetchCategoryId: curCategoryId
        }, this.initData)
      }
    })
  }

  getArticle = async function (params) {
    const res = await API.GetArticles({
      open_flag: 1,
      ...params
    })
    if (res.code !== 200) return []
    return res.result.rows
  }

  fetchData = (params = {}) => {

    const { fetchCategoryId, fetchHomeSearchKey } = this.state
    if (fetchHomeSearchKey) {
      params.fetch_search_key = fetchHomeSearchKey
    }
    if (fetchCategoryId) {
      params.fetch_category_id = fetchCategoryId
    }

    return new Promise((resolve, reject) => {
      this.getArticle(params).then(rows => {
        resolve(rows)
      })
    })
  };

  handleInfiniteOnLoad = async () => {
    return
    if (this.state.isLoading) return
    let { list } = this.state;
    this.setState({
      isLoading: true,
    });
    if (list.length > 1) {
      // message.warning('Infinite List loaded all');
      this.setState({
        hasMore: false,
        isLoading: false,
      });
      return;
    }
    const res = await this.fetchData()
  
    list = list.concat(res);
    this.setState({
      list,
      isLoading: false,
    });
  };

  initData = async () => {
    window.scrollTo(0, 0);
    const list = await this.fetchData()
    this.setState({ list })
  }

  async componentDidMount () {
    window.addEventListener('scroll', this.handleScroll);

    this.initData()
  }

  handleScroll = (event) => {
    // 滚动条高度
    const clientHeight = document.documentElement.clientHeight; // 可视区域高度
    const scrollTop = document.documentElement.scrollTop;  // 滚动条滚动高度

    // 样式的高度
    const bodyContentTop = 64 + 24

    if (!this.BottomChild.current) return

    if ((scrollTop + clientHeight + 30) >= (this.BottomChild.current.offsetTop + bodyContentTop)) {
      this.handleInfiniteOnLoad()
    }
  }

  locationArticle = (id) => {
    this.props.history.push({
      pathname: `/article/${id}`
    })
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {
      return;
    };
  }

  render () {
    const { state, locationArticle } = this
    const { isLoading, fetchCategoryId } = state

    return (
      <div>
        {fetchCategoryId && <Row gutter={18} style={{ marginBottom: '12px' }}>
          <Col span={24}>
          <Tag color="green" closable onClose={
            () => this.props.updateCategoryId(null)
          }>
            {this.props.categories.filter(c => {
              if (c.id === fetchCategoryId) return true
            })[0].title}
          </Tag>
          </Col>
        </Row>}
        <Row gutter={18}>
          <Col span={24}>
            <List
              className="blog-list-component"
              dataSource={state.list}
              rowKey={item => item.id}
              loading={isLoading}
              renderItem={item => {
                const imgContent = item.main_image_url && (
                  <div
                    className="list-item-pic"
                    style={{
                      backgroundImage: `url("${process.env.PUBLIC_URL}${item.main_image_url}")`,
                      height: item.type === 'LARGE' ? '200px' : '120px'
                    }}
                  >
                    <div className="on-top">
                      <VerticalAlignTopOutlined />
                    </div>
                  </div>
                )
                const normalContent = (
                  <div className="list-item-content">
                    <div className="list-item-content-left">
                      <div className="list-item-title" onClick={() => locationArticle(item.id)}>
                        {item.title}
                      </div>
                      <div className="list-item-belong-category">
                        {item.categories.map(categoryId => {
                          const curCat = this.props.categories.filter(cat => {
                            if (cat.id === categoryId) return true
                          })[0]
                          return <Tag color="gold" key={categoryId}>{curCat && curCat.title}</Tag>
                        })}
                      </div>
                      <div className="list-item-sub-title">
                        {item.intro}
                      </div>
                      <div className="list-item-action">
                        <div className="record-items">
                          <div className="record-item">
                            <EyeOutlined />
                            <div className="record-num">0</div>
                          </div>
                          <div className="record-item">
                            <LikeOutlined />
                            <div className="record-num">0</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {
                      item.type !== 'MIDDLE' &&
                      <div className="list-item-content-right" onClick={() => locationArticle(item.id)}>
                        MORE <ArrowRightOutlined />
                      </div>
                    }
                  </div>
                )
                const largeCard = <div></div>

                return (
                  <List.Item className="list-item">
                    <div className="list-item-wrapper">
                      {item.type === 'LARGE' && (
                        <div>
                          <div>
                            {imgContent}
                          </div>
                          <div>
                            {normalContent}
                          </div>
                        </div>
                      )}
                      {item.type === 'MIDDLE' && (
                        <div style={{
                          display: 'flex'
                        }}>
                          <div style={{ flex: '1', width: '0' }}>
                            {normalContent}
                          </div>
                          <div style={{ width: '200px', padding: '20px 20px 20px 0px' }}>
                            {imgContent}
                          </div>
                        </div>
                      )}
                      {item.type === 'SMALL' && normalContent}
                    </div>
                  </List.Item>
                )
              }}
            />
            <div className="bottom-more" ref={this.BottomChild}>
              {this.state.isLoading && this.state.hasMore && (
                <div className="demo-loading-container">
                  <Spin tip="正在加载更多..." />
                </div>
              )}
            </div>
            {/* <div className="App">
              <header className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
                <p>
                  Edit <code>src/App.js</code> and save to reload.
                </p>
                <a
                  className="App-link"
                  href="https://reactjs.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn React
                </a>
              </header>
            </div> */}
          </Col>
        </Row>
      </div>
    )
  }
}

export default HomeList
